<template>
  <v-overlay :value="dialog" color="overlayColor" opacity="0.95">
    <v-container @keydown.enter="confirm">
      <v-row class="pa-10 text-center">
        <div v-if="error" class="col-sm-1 col-md-3"></div>
        <div v-if="error" class="col-sm-10 col-md-6">
          <v-alert class="mt-5 red" border="left" text>
            {{ errorMsg }}
          </v-alert>
        </div>
        <div class="col-12 white--text"></div>
        <div class="col-md-12 col-sm-12">
          <input
            type="password"
            id="custom-input"
            :placeholder="
              $t('document_list.enter_here_the_pin_of_your_certificate')
            "
            v-model="pinCode"
          />
        </div>
        <div class="col-12">
          <v-btn
            class="footer-text-btn"
            :disabled="this.pinCode.length < 1"
            @click="confirm()"

          >
            {{ $t("ok") }}
          </v-btn>
        </div>
      </v-row>
    </v-container>
  </v-overlay>
</template>

<script>
export default {
  name: "certificate-pin-modal",
  props: {
    dialog: Boolean,
    error: Boolean,
    errorMsg: String,
  },
  data: function() {
    return {
      pinCode: "",
    };
  },
  computed: {
  overlayColor() {
        return this.$store.state.common.appBarColor;
    },
  },
  watch: {
    dialog() {
      if (this.dialog && !this.error) {
        this.pinCode = "";
      }
    },
  },
  methods: {
    confirm() {
      console.log("Emit submitCertificatePin con PIN:", this.pinCode);
      this.$emit("submitCertificatePin", this.pinCode);
//      this.$emit("update:dialog", false); // 🔥 Cerrar el modal en el padre
    },
  },
};
</script>
